import { FieldModel } from '@cibo/core'
import { BiomassBurningCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface BiomassBurningCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const BiomassBurningCell = ({
  value,
  task,
  year,
  selectedField,
}: BiomassBurningCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="biomassBurning"
    >
      <BiomassBurningCellDisplay value={value} />
    </TraitCellContainer>
  )
}
